import { ProductType } from "./product-type";
import { ProductSubtype } from "./product-subtype";

export class ProductConfiguration {
  private productType = new ProductType();
  private productSubType = new ProductSubtype();
  private purchaseEnabled: boolean;
  private subsidyEnabled: boolean;
  private subsidy: number;
  private discountEnabled: boolean;
  private DiscountPercentValue: number;
  private FormPayment : string;

  setProductType(type: ProductType): void {
    this.productType = type;
  }

  getProductType(): ProductType {
    return this.productType;
  }

  setProductSubType(subType: ProductSubtype): void {
    this.productSubType = subType;
  }

  getProductSubType(): ProductSubtype {
    return this.productSubType;
  }

  setPurchaseEnabled(permission: boolean): void {
    this.purchaseEnabled = permission;
  }

  getPurchaseEnabled(): boolean {
    return this.purchaseEnabled;
  }

  setSubsidyEnabled(permission: boolean): void {
    this.subsidyEnabled = permission;
  }

  getSubsidyEnabled(): boolean {
    return this.subsidyEnabled;
  }

  setSubsidy(value: number): void {
    this.subsidy = value;
  }

  getSubsidy(): number {
    return this.subsidy;
  }

  setDiscountEnabled(permission: boolean): void {
    this.discountEnabled = permission;
  }

  getDiscountEnabled(): boolean {
    return this.discountEnabled;
  }

  setDiscountPercentValue(value: number): void {
    this.DiscountPercentValue = value;
  }

  getDiscountPercentValue(): number {
    return this.DiscountPercentValue;
  }
  
  setFormPayment(value: string): void {
    this.FormPayment = value;
  }

  getFormPayment(): string {
    return this.FormPayment;
  }

}
